import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: `${API_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token de autenticación
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getJurisdicciones = async () => {
  const response = await api.get('/jurisdicciones');
  return response.data;
};

export const consultarMultas = async (patente, jurisdicciones = null) => {
  const response = await api.post('/consultar', {
    patente,
    jurisdicciones,
  });
  return response.data;
};

export const getHistorial = async (patente) => {
  const response = await api.get(`/historial/${patente}`);
  return response.data;
};

// Auth
export const authLogin = async (username, password) => {
  const response = await api.post('/auth/login', { username, password });
  return response.data;
};

export const authLogout = async () => {
  const response = await api.post('/auth/logout');
  return response.data;
};

export const authMe = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

// Panel
export const getEstadisticas = async () => {
  const response = await api.get('/panel/estadisticas');
  return response.data;
};

export const getConsultas = async (params) => {
  const response = await api.get('/panel/consultas', { params });
  return response.data;
};

export const getConsultaMultas = async (consultaId) => {
  const response = await api.get(`/panel/consultas/${consultaId}/multas`);
  return response.data;
};

export const getLogs = async (params) => {
  const response = await api.get('/panel/logs', { params });
  return response.data;
};

// Clientes API
export const getClientes = async (params) => {
  const response = await api.get('/panel/clientes', { params });
  return response.data;
};

export const crearCliente = async (data) => {
  const response = await api.post('/panel/clientes', data);
  return response.data;
};

export const getCliente = async (clienteId) => {
  const response = await api.get(`/panel/clientes/${clienteId}`);
  return response.data;
};

export const generarApiKeys = async (clienteId) => {
  const response = await api.post(`/panel/clientes/${clienteId}/generar-api-keys`);
  return response.data;
};

export const actualizarWebhook = async (clienteId, webhookUrl) => {
  const response = await api.put(`/panel/clientes/${clienteId}/webhook`, { webhook_url: webhookUrl });
  return response.data;
};

export const actualizarCreditos = async (clienteId, creditos) => {
  const response = await api.put(`/panel/clientes/${clienteId}/creditos`, { creditos });
  return response.data;
};

export const actualizarApiEnabled = async (clienteId, apiEnabled) => {
  const response = await api.put(`/panel/clientes/${clienteId}/api-enabled`, { api_enabled: apiEnabled });
  return response.data;
};

export const getConsultasCliente = async (clienteId, params) => {
  const response = await api.get(`/panel/clientes/${clienteId}/consultas-api`, { params });
  return response.data;
};

// Consultas API panel
export const getConsultasAPI = async (params) => {
  const response = await api.get('/panel/consultas-api', { params });
  return response.data;
};

export const getConsultaAPIDetalle = async (consultaId) => {
  const response = await api.get(`/panel/consultas-api/${consultaId}`);
  return response.data;
};

export default api;
